module.exports = __webpack_public_path__ + "static/media/exit.6b97ab53.svg";